// Переключение цвета шапки в зависимости от секции под ней
// (data-header="light" — белый текст шапки, "dark" — чёрный)
const header = document.getElementById('header');
const observed = document.querySelectorAll('[data-header]');

if (header) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          header.classList.toggle('is-light', entry.target.dataset.header === 'light');
        }
      });
    },
    // срабатывает, когда верх секции проходит под шапкой
    { rootMargin: '-1% 0px -95% 0px', threshold: 0 }
  );
  observed.forEach((s) => observer.observe(s));
}

// Мобильное меню: бургер открывает, крестик/ссылка/Esc закрывают.
// Блокируем прокрутку фона и держим aria-expanded в актуальном состоянии.
const burger = document.getElementById('burger');
const mobileMenu = document.getElementById('mobileMenu');
if (burger && mobileMenu) {
  const menuClose = document.getElementById('mobileMenuClose');
  const setMenu = (open) => {
    mobileMenu.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('menu-open', open);
  };
  burger.addEventListener('click', () =>
    setMenu(!mobileMenu.classList.contains('is-open'))
  );
  if (menuClose) menuClose.addEventListener('click', () => setMenu(false));
  mobileMenu.querySelectorAll('a').forEach((a) =>
    a.addEventListener('click', () => setMenu(false))
  );
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) setMenu(false);
  });
}

// Куки-плашка (есть только на главной)
const cookie = document.getElementById('cookie');
if (cookie) {
  document.getElementById('cookieAccept').addEventListener('click', () => cookie.classList.add('is-hidden'));
  document.getElementById('cookieClose').addEventListener('click', () => cookie.classList.add('is-hidden'));
}

// ------------------------------------------------------------
// Страница продукта: выбор цвета/размера/количества.
// Данные и id вариантов лежат в <script id="productData">.
// Кнопка "Add to cart" ведёт на нативную ссылку Shopify
// /cart/{variantId}:{qty} — совместимо с площадкой без бэкенда.
// ------------------------------------------------------------
const productEl = document.querySelector('[data-product]');
const productDataEl = document.getElementById('productData');

if (productEl && productDataEl) {
  const data = JSON.parse(productDataEl.textContent);

  const gallery     = productEl.querySelector('[data-gallery]');
  const galleryPrev = productEl.querySelector('[data-gallery-prev]');
  const galleryNext = productEl.querySelector('[data-gallery-next]');
  const colorWrap  = productEl.querySelector('[data-colors]');
  const colorLabel = productEl.querySelector('[data-color-label]');
  const sizeWrap   = productEl.querySelector('[data-sizes]');
  const qtyValue   = productEl.querySelector('[data-qty]');
  const qtyDec     = productEl.querySelector('[data-qty-dec]');
  const qtyInc     = productEl.querySelector('[data-qty-inc]');
  // Кнопок «Add to cart» может быть несколько (основная + липкая мобильная).
  const addBtns    = Array.from(productEl.querySelectorAll('[data-add-to-cart]'));

  // Стартовый цвет — первый из data.order, если он вообще есть.
  const state = { color: (data.order && data.order[0]) || null, size: null, qty: 1 };

  // Запись в data.colors по текущему цвету (или null, если данных нет).
  function colorEntry() {
    return (state.color && data.colors && data.colors[state.color]) || null;
  }

  function renderGallery() {
    if (!gallery) return;
    const entry = colorEntry();
    if (!entry || !entry.images) return;
    gallery.innerHTML = entry.images
      .map((o, i) =>
        `<img src="${o.src}" alt="${o.alt}" ` +
        (i === 0 ? 'loading="eager" fetchpriority="high"' : 'loading="lazy"') +
        '>')
      .join('');
    gallery.scrollLeft = 0;
    updateArrows();
  }

  // Тонкие стрелки листаемой ленты (моб.): показываем ту, куда ещё можно
  // листать. Считаем по фактической прокрутке — работает при любом числе фото.
  function updateArrows() {
    if (!gallery || !galleryPrev || !galleryNext) return;
    const max = gallery.scrollWidth - gallery.clientWidth;
    const x = gallery.scrollLeft;
    const scrollable = max > 2;
    galleryPrev.hidden = !scrollable || x <= 2;
    galleryNext.hidden = !scrollable || x >= max - 2;
  }

  if (gallery && galleryPrev && galleryNext) {
    gallery.addEventListener('scroll', updateArrows, { passive: true });
    galleryNext.addEventListener('click', () =>
      gallery.scrollBy({ left: gallery.clientWidth, behavior: 'smooth' })
    );
    galleryPrev.addEventListener('click', () =>
      gallery.scrollBy({ left: -gallery.clientWidth, behavior: 'smooth' })
    );
    window.addEventListener('resize', updateArrows);
  }

  function currentVariantId() {
    const entry = colorEntry();
    if (!entry || !entry.variants) return null;
    return state.size ? entry.variants[state.size] : null;
  }

  function updateAddBtn() {
    const variantId = currentVariantId();
    addBtns.forEach((btn) => {
      if (variantId) {
        // /cart/add — ДОБАВЛЯЕТ товар в корзину (не заменяет её). Fallback без JS.
        btn.href = `${data.cartBase}/add?id=${variantId}&quantity=${state.qty}`;
        btn.classList.remove('is-disabled');
        btn.removeAttribute('aria-disabled');
        btn.textContent = 'Add to cart';
      } else {
        btn.href = '#';
        btn.classList.add('is-disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = 'Select a size';
      }
    });
  }

  if (colorWrap) {
    colorWrap.querySelectorAll('[data-color]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.color = btn.dataset.color;
        colorWrap.querySelectorAll('[data-color]')
          .forEach((b) => b.classList.toggle('is-selected', b === btn));
        if (colorLabel) colorLabel.textContent = state.color;
        renderGallery();
        updateAddBtn();
      });
    });
  }

  if (sizeWrap) {
    sizeWrap.querySelectorAll('[data-size]').forEach((el) => {
      el.addEventListener('click', () => {
        state.size = el.dataset.size;
        sizeWrap.querySelectorAll('[data-size]')
          .forEach((s) => s.classList.toggle('is-selected', s === el));
        updateAddBtn();
      });
    });
  }

  if (qtyDec && qtyInc && qtyValue) {
    qtyDec.addEventListener('click', () => {
      state.qty = Math.max(1, state.qty - 1);
      qtyValue.textContent = state.qty;
      updateAddBtn();
    });
    qtyInc.addEventListener('click', () => {
      state.qty = Math.min(10, state.qty + 1);
      qtyValue.textContent = state.qty;
      updateAddBtn();
    });
  }

  addBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      if (btn.classList.contains('is-disabled')) {
        e.preventDefault();
        if (sizeWrap) {
          sizeWrap.classList.add('needs-attention');
          sizeWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => sizeWrap.classList.remove('needs-attention'), 1200);
        }
        return;
      }
      const variantId = currentVariantId();
      if (!variantId) return;
      // Добавляем через Cart AJAX API: корзина ДОПОЛНЯЕТСЯ, а не перезаписывается,
      // затем переходим на страницу корзины (Bag).
      e.preventDefault();
      addBtns.forEach((b) => { b.textContent = 'Adding…'; });
      fetch(`${data.cartBase}/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: state.qty })
      })
        .then((r) => { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(() => { window.location.href = data.cartBase; })
        .catch(() => { window.location.href = btn.href; });
    });
  });

  renderGallery();
  updateAddBtn();
}

// ------------------------------------------------------------
// Всплывающий баннер подписки на рассылку.
// Показывается через N секунд после захода; после закрытия или
// успешной подписки не появляется снова в течение указанного числа
// дней (запоминаем в localStorage). Текст/картинку задаёт секция
// pc-newsletter-popup в редакторе темы.
// ------------------------------------------------------------
const np = document.getElementById('newsletterPopup');
if (np) {
  const KEY = 'pc_np_dismissed';
  const days = parseInt(np.dataset.days, 10) || 14;
  const delayMs = (parseFloat(np.dataset.delay) || 0) * 1000;
  const justSubscribed = !!np.querySelector('[data-np-posted]');
  // В режиме редактора темы показываем всегда, чтобы владелец видел правки.
  const designMode = !!(window.Shopify && window.Shopify.designMode);

  let lastFocused = null;

  const focusables = () =>
    Array.from(np.querySelectorAll(
      'button, [href], input, textarea, select, [tabindex]:not([tabindex="-1"])'
    )).filter((el) => !el.disabled && el.offsetParent !== null);

  // Удержание фокуса внутри диалога (focus trap): Tab по кругу.
  const trap = (e) => {
    if (e.key !== 'Tab') return;
    const items = focusables();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  const openPopup = () => {
    lastFocused = document.activeElement;
    np.classList.add('is-open');
    np.setAttribute('aria-hidden', 'false');
    document.body.classList.add('np-open');
    np.addEventListener('keydown', trap);
    // Переносим фокус внутрь диалога (на поле email или кнопку закрытия).
    const items = focusables();
    const target = np.querySelector('input[type="email"]') || items[0];
    if (target) target.focus();
  };

  const remember = () => {
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  };

  const closePopup = () => {
    np.classList.remove('is-open');
    np.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('np-open');
    np.removeEventListener('keydown', trap);
    remember();
    // Возвращаем фокус туда, откуда открыли попап; если попап открылся сам
    // (фокуса не было) — просто снимаем фокус со скрытого элемента.
    if (lastFocused && lastFocused !== document.body &&
        typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    } else if (document.activeElement && np.contains(document.activeElement)) {
      document.activeElement.blur();
    }
  };

  const recentlyDismissed = () => {
    try {
      const t = parseInt(localStorage.getItem(KEY), 10);
      return t && (Date.now() - t) < days * 86400000;
    } catch (e) { return false; }
  };

  np.querySelectorAll('[data-np-close]').forEach((el) =>
    el.addEventListener('click', closePopup)
  );
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && np.classList.contains('is-open')) closePopup();
  });

  if (justSubscribed) {
    // Подписка только что оформлена — показываем «спасибо» и больше не надоедаем.
    openPopup();
    remember();
  } else if (designMode) {
    openPopup();
  } else if (!recentlyDismissed()) {
    setTimeout(openPopup, delayMs);
  }
}

// ------------------------------------------------------------
// Форма отзыва договора (EU withdrawal). Двухшаговая:
// 1) ввод данных → 2) проверка → отправка встроенной формой Shopify
// (contact) → магазин получает письмо. Экран «получено» показывается
// после перезагрузки, когда form.posted_successfully? = true; значения
// подставляются из sessionStorage (их сохраняем перед отправкой).
// ------------------------------------------------------------
const withdrawal = document.querySelector('[data-withdrawal]');
if (withdrawal) {
  const SKEY = 'pc_withdrawal_last';
  const nativeForm  = withdrawal.querySelector('form');
  const formStep    = withdrawal.querySelector('[data-withdrawal-form]');
  const confirmStep = withdrawal.querySelector('[data-withdrawal-confirm]');
  const doneStep    = withdrawal.querySelector('[data-withdrawal-done]');
  const reviewBtn   = withdrawal.querySelector('[data-withdrawal-review]');
  const backBtn     = withdrawal.querySelector('[data-withdrawal-back]');

  const val = (sel) => {
    const el = withdrawal.querySelector(sel);
    return el ? el.value.trim() : '';
  };
  const currentValues = () => ({
    orderNumber: val('#orderNumber'),
    email: val('#email'),
    orderDate: val('#orderDate'),
    items: val('#items')
  });

  const fill = (scope, data) => {
    if (!scope) return;
    scope.querySelectorAll('[data-sum]').forEach((el) => {
      const k = el.getAttribute('data-sum');
      el.textContent = data[k] && data[k].length ? data[k] : '—';
    });
  };

  // Экран «получено» после перезагрузки: подставляем сохранённые значения.
  if (doneStep) {
    try {
      const saved = JSON.parse(sessionStorage.getItem(SKEY) || '{}');
      fill(doneStep, saved);
      sessionStorage.removeItem(SKEY);
    } catch (e) {}
  }

  // Шаг 1 → проверка данных → показать шаг подтверждения.
  if (reviewBtn && nativeForm && formStep && confirmStep) {
    reviewBtn.addEventListener('click', () => {
      const order = withdrawal.querySelector('#orderNumber');
      const email = withdrawal.querySelector('#email');
      if (!order.value.trim() || !email.value.trim() || !email.checkValidity()) {
        nativeForm.reportValidity();
        return;
      }
      fill(confirmStep, currentValues());
      formStep.hidden = true;
      confirmStep.hidden = false;
      confirmStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // «Edit details» — вернуться к вводу.
  if (backBtn && formStep && confirmStep) {
    backBtn.addEventListener('click', () => {
      confirmStep.hidden = true;
      formStep.hidden = false;
      formStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // Перед реальной отправкой запоминаем значения — чтобы экран «получено»
  // (после перезагрузки) мог показать номер заказа и email.
  if (nativeForm) {
    nativeForm.addEventListener('submit', () => {
      try { sessionStorage.setItem(SKEY, JSON.stringify(currentValues())); } catch (e) {}
    });
  }
}
